/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Build_Loading_CatalogueInputs */

const en_us2_plan_build_loading_catalogue = /** @type {(inputs: Plan_Build_Loading_CatalogueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Loading the catalogue…`)
};

const pt_br2_plan_build_loading_catalogue = /** @type {(inputs: Plan_Build_Loading_CatalogueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Carregando o catálogo…`)
};

const es_419_plan_build_loading_catalogue = /** @type {(inputs: Plan_Build_Loading_CatalogueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cargando el catálogo…`)
};

const pt_pt2_plan_build_loading_catalogue = /** @type {(inputs: Plan_Build_Loading_CatalogueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A carregar o catálogo…`)
};

const fr_fr2_plan_build_loading_catalogue = /** @type {(inputs: Plan_Build_Loading_CatalogueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chargement du catalogue…`)
};

const de_de2_plan_build_loading_catalogue = /** @type {(inputs: Plan_Build_Loading_CatalogueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Katalog wird geladen…`)
};

const it_it2_plan_build_loading_catalogue = /** @type {(inputs: Plan_Build_Loading_CatalogueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Caricamento del catalogo…`)
};

/**
* | output |
* | --- |
* | "Loading the catalogue…" |
*
* @param {Plan_Build_Loading_CatalogueInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const plan_build_loading_catalogue = /** @type {((inputs?: Plan_Build_Loading_CatalogueInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Build_Loading_CatalogueInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_plan_build_loading_catalogue(inputs)
	if (locale === "es-419") return es_419_plan_build_loading_catalogue(inputs)
	if (locale === "pt-PT") return pt_pt2_plan_build_loading_catalogue(inputs)
	if (locale === "fr-FR") return fr_fr2_plan_build_loading_catalogue(inputs)
	if (locale === "de-DE") return de_de2_plan_build_loading_catalogue(inputs)
	if (locale === "it-IT") return it_it2_plan_build_loading_catalogue(inputs)
	return en_us2_plan_build_loading_catalogue(inputs)
});
export { plan_build_loading_catalogue as "plan-build.loading_catalogue" }